import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { speak, stopVoice } from '../../games/core/voice';
import { useSessionStore } from '../../store/session';

export const GARAGE_LINE = 'Nå er bilen trøtt. Den sover i garasjen. Ha det, og takk for hjelpen!';

/** Calm end of a play session: the truck parks and sleeps. */
export const GarageScreen: React.FC = () => {
  const navigate = useNavigate();
  const resetSession = useSessionStore((s) => s.reset);

  useEffect(() => {
    resetSession();
    void speak(GARAGE_LINE);
    return () => stopVoice();
  }, [resetSession]);

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center gap-6 bg-gradient-to-b from-[#1d3557] via-[#457b9d] to-[#a8dadc] p-6"
      data-name="garage-screen"
    >
      <div className="relative">
        <div className="rounded-t-[3rem] bg-[#E76F51] px-14 pt-10 pb-6 shadow-2xl">
          <div className="rounded-xl bg-[#264653] px-10 py-6">
            <motion.span
              className="block text-7xl"
              initial={{ x: -120, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              transition={{ duration: 1.6, ease: 'easeOut' }}
              aria-hidden
            >
              🚛
            </motion.span>
          </div>
        </div>
        <motion.span
          className="absolute -top-6 right-2 text-5xl"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: [0, 1, 1, 0], y: [10, -10, -20, -30] }}
          transition={{ delay: 1.8, duration: 2.4, repeat: Infinity }}
          aria-hidden
        >
          💤
        </motion.span>
      </div>
      <p className="max-w-md text-center font-display text-3xl font-bold text-white drop-shadow">
        God natt, søppelbil!
      </p>
      <button
        type="button"
        data-name="garage-home"
        onClick={() => navigate('/')}
        className="min-h-[96px] min-w-[96px] rounded-2xl bg-white px-8 text-4xl shadow active:scale-95"
        aria-label="Hjem"
      >
        🏠
      </button>
    </div>
  );
};

export default GarageScreen;
